import { Component } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { DialogControlService } from '@shared/services/dialog-control.service';
import { BookingPaymentStatusPopupComponent } from '../booking-payment-status-popup/booking-payment-status-popup.component';
import { CommonService } from '@core/services/common.service';

@Component({
  selector: 'app-booking-payment-status',
  templateUrl: './booking-payment-status.component.html',
  styleUrls: ['./booking-payment-status.component.scss']
})
export class BookingPaymentStatusComponent {
  bookingId: string | null = null;
  roleEnum: string;

  constructor(private readonly commonApiService: CommonService, private readonly route: ActivatedRoute, private readonly dialogControlService: DialogControlService) {
    this.route.paramMap.subscribe(params => {
      this.bookingId = params.get('id');
      this.roleEnum = params.get('roleEnum');
      this.fetchPaymentStatus();
    });
  }

  fetchPaymentStatus(): void {
    if (this.bookingId) {
      this.commonApiService.getBookingPaymentStatus(this.bookingId, this.roleEnum).subscribe(
        (response: any) => {
          window.location.href = response.data.url;
        },
        (error) => {
          this.dialogControlService.openDialog(BookingPaymentStatusPopupComponent, {
            styleClass: 'important-msg-model',
            data: {
              extraError : error?.error?.errorMessage,
              bodyText: error.error.message,
            },
          });
        }
      );
    }
  }
}
